const phone = '30 274 0653'
const email = 'jforce@jumia.com.gh'
const supportedLanguages = ['en']
const personalInfo = {
  phoneNumberMask: '#### ### ####'
}
const paymentMethods = {
  bankAccountMask: '### ### ####'
}

export {
  // auxiliary objects
  phone,
  email,

  // languages
  supportedLanguages,

  // personal info
  personalInfo,

  // payment methods
  paymentMethods
}
